module.exports = __webpack_public_path__ + "static/media/flow.ba6b879ac460cfd34470cda9a48b7604.svg";